<template>
	<div class="app">
		<!-- Income access affiliate tracker -->
		<iframe
			style="display: none"
			id="incomeaccess"
			v-if="show_income_access"
			:src="`http://wlbetika.adsrv.eacdn.com/Processing/Pixels/Registration.ashx?PlayerID=${user.id}`"
		></iframe>
		<component
			:is="$store.getters.layout"
			v-if="$store.getters.sportsLoaded && countryConfigsLoaded"
		/>
		<div id="app" v-else>
			<div class="app-loader">
				<img :src="`${env.logoUrl}`" width="100px" />
				<div class="app-loader-animation"></div>
			</div>
		</div>
		<!-- Portal targets -->
		<portal-target name="bottom-sheet-stack" />
		<portal-target name="bottom-sheet" />
		<portal-target name="modal" />
		<portal-target name="modal-two" />
		<portal-target name="fullscreen" />
	</div>
</template>

<script>
import isPast from "date-fns/isPast";
import parse from "date-fns/parse";
import _, { isNull } from "lodash";
import parser from "../assets/scripts/ua-parser.min.js";
import { getCountryConfigs } from "../config";
import Desktop from "../layouts/Desktop.vue";
import Mobile from "../layouts/Mobile.vue";
import { setLocale } from "../plugins/i18n";
import { getConfigurableRoutes } from "../router";
import { setEnv } from "../utils/env";
import { appendCountryToTitle } from "../utils/metaTitleHelper";
import CountrySelector from "./Shared/CountrySelector.vue";
import analyticsPlugin from "../utils/eventAnalytics/plugin";

export default {
	name: "app",
	components: { Mobile, Desktop, CountrySelector },
	data() {
		return {
			online: window.navigator.onLine,
			liveMatches: [],
			matchesInBetslip: [],
			btag: null,
			affiliateData: null,
			affiliateMatchData: null,
			affiliateMatchMeta: null,
			show_income_access: false,
			selectedCountryCode: "",
			selectedCountry: "",
			metaDetails: {},
		};
	},
	mounted() {
		let ajax = new XMLHttpRequest();
		const routeName = `/${window.location.pathname.split("/")[2]}`;
		ajax.open("GET", this.env.sportIconsSpriteUrl, true);
		ajax.send();
		ajax.onload = function (e) {
			var div = document.createElement("div");
			div.innerHTML = ajax.responseText;
			div.style.display = "none";
			document.body.insertBefore(div, document.body.childNodes[0]);
		};
		this.$store.dispatch("getGA4EventConfigData");
		this.init();
		// console.log(this.utmSource, 'this is the utm source')
		if (this.env.country === "DRC") {
			this.filterMetaDataByUrl(routeName);
		}
		return (
			this.env.showPopUpUnabletoReach &&
			this.$notifications.add({
				message: `Unable to reach us via call? We sincerely apologize for this.Please send us a message on WhatsApp 0${this.env.whatsappNumber} or a DM on any of our social media platforms.`,
				title: "Unable to reach us",
				type: "info",
				duration: null,
			})
		);
	},
	created() {
		let vm = this;
		// Register sports list events
		vm.$root.$on("reset-sports-list", vm.resetSportsList);
		vm.$root.$on("refresh-sports-list", vm.refreshSportsList);
		vm.$root.$on("refresh-live-sports-list", vm.getLiveSports);
	},
	beforeDestroy() {
		let vm = this;
		// De register sports list events
		vm.$root.$off("reset-sports-list", vm.resetSportsList);
		vm.$root.$off("refresh-sports-list", vm.refreshSportsList);
  		this.$root.$off("refresh-live-sports-list", vm.getLiveSports);
	},
	metaInfo() {
		let vm = this;
		let title = vm.metaDetails.metaTitle || vm.env.websiteTitle;
		let description = vm.metaDetails.metaDescription || vm.env.websiteDescription;

		// Use helper function to append country
		title = appendCountryToTitle(title, vm.env.country);

		return {
			title: title,
			description: description,
			meta: [
				{
					vmid: "description",
					name: "description",
					content: description,
				},
				{
					vmid: "og:title",
					property: "og:title",
					content: title,
				},
				{
					vmid: "og:site_name",
					property: "og:site_name",
					content: "betika",
				},
				{
					vmid: "og:type",
					property: "og:type",
					content: "website",
				},
				{
					vmid: "og:url",
					property: "og:url",
					content: `${this.env.websiteUrl}`,
				},
				{
					vmid: "og:image",
					property: "og:image",
					content: `${this.env.websiteOpenGraphImage}`,
				},
				{
					vmid: "og:description",
					property: "og:description",
					content: description,
				},
				{
					vmid: "twitter:card",
					name: "twitter:card",
					content: "summary_large_image",
				},
				{
					vmid: "twitter:site",
					name: "twitter:site",
					content: `${this.env.socialUrls.twitter}`,
				},
				{
					vmid: "twitter:title",
					name: "twitter:title",
					content: title,
				},
				{
					vmid: "twitter:description",
					name: "twitter:description",
					content: description,
				},
				{
					vmid: "twitter:creator",
					name: "twitter:creator",
					content: `${this.env.socialUserNames.twitterUsername}`,
				},
				{
					vmid: "twitter:image",
					name: "twitter:image",
					content: `${this.env.websiteOpenGraphImage}`,
				},
				{
					vmid: "name",
					itemprop: "name",
					content: title,
				},
				{
					vmid: "description",
					itemprop: "description",
					content: description,
				},
				{
					vmid: "image",
					itemprop: "image",
					content: `${this.env.websiteOpenGraphImage}`,
				},
				{
					vmid: "keywords",
					name: "keywords",
					content: `${this.env.websiteKeywords}`,
				},
			],
		};
	},
	watch: {
		loggedIn() {
			var vm = this;
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		$route(to, from) {
			var vm = this;
			if (this.env.country === "DRC") {
				this.filterMetaDataByUrl(to.path);
			}
			if (window.location.hash.indexOf("live") < 0) {
				window.clearInterval(window.localStorage.getItem("liveUpdateID"));
				window.clearInterval(window.localStorage.getItem("liveMatchUpdateID"));
			}
		},
		online() {
			if (!this.online) {
				this.$notifications.add({
					message:
						"You are offline. Please refresh your matches once you get back online",
					title: "Offline ",
					type: "error",
					duration: 5000,
				});
			}
			if (this.online) {
				this.$notifications.add({
					message: "You are back online. Please refresh your matches",
					title: "Online",
					type: "success",
					duration: 5000,
				});
			}
		},
	},
	computed: {
		isLoggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		user: {
			get() {
				return this.$store.getters.user;
			},
			set(u) {
				this.$store.commit("setUser", u);
			},
		},
		countryConfigsLoaded() {
			return this.$store.getters.countryConfigsLoaded;
		},
		ipCheckStatusComplete() {
			return this.$store.getters.ipCheckStatus;
		},
		amount() {
			let vm = this;
			if (isNull(vm.$store.getters.stake)) {
				vm.$store.commit("updateStake", parseFloat(vm.env.minimumBetAmount));
				return vm.env.minimumBetAmount;
			} else {
				return vm.$store.getters.stake;
			}
		},
		affiliatesPromoData() {
			return this.env.affiliatesPromoData;
		},
		affiliatesPromoDataCondition() {
			return (
				this.env.country === this.env.affiliatesPromoData.country &&
				isAffilateActive &&
				Object.keys(this.env.affiliatesPromoData.AffiliateMetaData).length !== 0
			);
		},
		utmSource() {
			return this.$store.getters.utmSource;
		},
	},
	methods: {
		getLiveSports() {
			let vm = this;
			return new Promise((resolve, reject) => {
				let url;
				url = `${LIVE_URL}uo/sports`;
				vm.$axios
					.get(url)
					.then((response) => {
						vm.$store.commit("UPDATE_LIVE_SPORTS", response.data);
						vm.$store.commit("UPDATE_LIVE_SPORTS_LOADED", true);
						resolve();
					})
					.catch((error) => {
						vm.$store.commit("UPDATE_LIVE_SPORTS_LOADED", true);
						vm.error = true;
						reject();
					});
			});
		},
		filterMetaDataByUrl(routeName) {
			// Default metadata values
			const defaultWebsiteTitle = this.env.websiteTitle;
			const defaultWebsiteDescription = this.env.websiteDescription;
			const defaultWebsiteOpenGraphImage = this.env.websiteOpenGraphImage;
			// Get paths with isActive set to true
			const pathsWithUseAff = Object.values(
				this.affiliatesPromoData.affiliateMetaData
			)
				.filter((metaData) => metaData.isActive)
				.map((metaData) => metaData.pathName);
			// Check if the current path has affiliate metadata
			if (!pathsWithUseAff.includes(routeName) || routeName === "/") {
				// Use default metadata if current path is not in pathsWithUseAff or if routeName is "/"
				this.metaDetails = {
					metaTitle: defaultWebsiteTitle,
					metaDescription: defaultWebsiteDescription,
					metaImage: defaultWebsiteOpenGraphImage,
				};
			} else {
				const metaItem =
					this.affiliatesPromoData.affiliateMetaData[routeName.split("/")[1]];
				// Check if metadata is found
				if (metaItem) {
					// Check if affiliate metadata exists and has openGraphImage
					if (metaItem.openGraphImage) {
						// Use affiliate metadata if available, otherwise use defaults
						const metaTitle = metaItem.title || defaultWebsiteTitle;
						const metaDescription =
							metaItem.description || defaultWebsiteDescription;
						const metaImage =
							metaItem.openGraphImage || defaultWebsiteOpenGraphImage;

						// Assign metadata details
						this.metaDetails = {
							metaTitle,
							metaDescription,
							metaImage,
						};
					} else {
						// Use default metadata if openGraphImage is missing
						this.metaDetails = {
							metaTitle: defaultWebsiteTitle,
							metaDescription: defaultWebsiteDescription,
							metaImage: defaultWebsiteOpenGraphImage,
						};
					}
				} else {
					// Use default metadata if metadata for the current path is not found
					this.metaDetails = {
						metaTitle: defaultWebsiteTitle,
						metaDescription: defaultWebsiteDescription,
						metaImage: defaultWebsiteOpenGraphImage,
					};
				}
			}
		},

		setCountryConfirmed(confirmedPayload) {
			let vm = this;
			let countryConfigs = getCountryConfigs();

			localStorage.setItem(
				"countryCode",
				JSON.stringify(confirmedPayload.countryCode)
			);
			setLocale(confirmedPayload.countryLocale);

			countryConfigs = getCountryConfigs();
			setEnv(countryConfigs);

			let configurableRoutes = getConfigurableRoutes();
			configurableRoutes.forEach((route) => {
				vm.$router.addRoute("rootLocaleRoute", route);
			});
			vm.init();
			// window.location.reload
		},
		getUserCountry() {
			let vm = this;
			vm.$axios.get(`${GEO_IP_URL}`).then((response) => {
				vm.selectedCountryCode = response.data.countryCode
					? response.data.countryCode.toUpperCase()
					: "KE";
				vm.selectedCountry = response.data.country
					? response.data.country
					: "KENYA";
				vm.$store.commit("SET_IP_CHECK_STATUS", true);
			});
		},
		getCompetitionFromUrl() {
			let competitionName = this.$route.params.competitionName;
			if (!competitionName)
				return {
					competition_id: null,
					competition_name: null,
				};
			let selectedCountry = this.$store.getters.countries.data.find(
				(country) => {
					return country.competitions.find((competition) => {
						return competition.urlSlug === competitionName;
					});
				}
			);
			let selectedCompetition = selectedCountry.competitions.find(
				(competition) => {
					return competition.urlSlug === competitionName;
				}
			);

			return selectedCompetition;
		},
		getSportFromUrl() {
			let sportName = this.$route.params.sportName;
			if (!sportName) return this.env.defaultSport;
			let selectedSport = this.$store.getters.sports.find((sport) => {
				return sport.sport_name.split(" ").join("-").toLowerCase() == sportName;
			});
			return selectedSport;
		},
		formatSportName(sportName) {
			return sportName.toLowerCase().replace(/\s/gi, "_").replace(/\-/gi, "_");
		},
		init: async function () {
			let vm = this;

			await vm.loadSportsList();

			if (!vm.countryConfigsLoaded) {
				vm.getUserCountry();
				return;
			}
			vm.$store.dispatch("getSports").then((sports) => {
				vm.$store.commit("SET_SPORTS", sports);
			});
			vm.handleDeeplink();
			window.showIncomeAccess = this.showIncomeAccess;
			window.forcePlaceBet = this.forcePlaceBet;
			vm.$store.commit("dataNotifier/setIsSaf");
			vm.$store.commit("cashout/initSettingsFromAPI");
			let utm_source = this.$utils.getParameterByName("utm_source");
			let utm_medium = this.$utils.getParameterByName("utm_medium");
			if (utm_source) {
				if (utm_medium) utm_source += `/${utm_medium}`;
				sessionStorage.setItem("affiliate", `${utm_source}`);
				localStorage.setItem("utm_source", utm_source);
			}
			if (this.$utils.getParameterByName("affiliate_id")) {
				sessionStorage.setItem(
					"affiliate",
					this.$utils.getParameterByName("affiliate_id")
				);
			}
			if (this.$utils.getParameterByName("affiliate")) {
				sessionStorage.setItem(
					"affiliate",
					this.$utils.getParameterByName("affiliate")
				);
			}
			if (this.$utils.getParameterByName("btag")) {
				localStorage.setItem("btag", this.$utils.getParameterByName("btag"));
			}
			const operaId = vm.getParameterByName("gaid");
			
			// Initialize GrowthBook for all users (logged in or not)
			// This ensures feature flags work for everyone
			try {
				if (!vm.$store.getters['growthbook/isGrowthBookInitialized']) {
					vm.$store.dispatch('growthbook/initializeGrowthBook')
						.then(() => {
							// Update user attributes if logged in
							if (vm.isLoggedIn) {
								vm.$store.dispatch('growthbook/updateUserAttributes', vm.$store.getters.user)
							}
						})
						.catch(e => {
							console.error('Failed to initialize GrowthBook:', e)
						})
				} else if (vm.isLoggedIn) {
					vm.$store.dispatch('growthbook/updateUserAttributes', vm.$store.getters.user)
				}
			} catch (e) {
				console.error('Failed to initialize GrowthBook:', e)
			}

			if (vm.isLoggedIn) {
				vm.$store.dispatch("freebets/getFreebets");
			}
			if (operaId) {
				vm.$store.dispatch("trackOperaId", operaId);
				vm.$cookie.set("gaid", operaId, 365);
				vm.$store.commit("addToAuthActions", () => {
					vm.$store.dispatch("trackOperaId", operaId);
				});
			}
			analyticsPlugin.getUserInfo();
			vm.$store.commit("addToAuthActions", () => {
				analyticsPlugin.getUserInfo();
				vm.$store.commit("cashout/initSettingsFromAPI");
			});

			vm.$store.dispatch("getLegal");

			//seo content block
			vm.$store.dispatch("getSeoContentBlock");
			vm.$store.dispatch("getMetaDataContent");

			// User Agent
			const _parser = new parser();
			let ua = _parser.getResult();

			localStorage.user_agent = JSON.stringify(ua);

			window.addEventListener("focus", () => {
				vm.$store.commit("dataNotifier/setIsSaf");
			});
			// Network status event listener
			window.addEventListener("online", () => {
				vm.online = true;
				vm.$store.commit("dataNotifier/setIsSaf");
			});

			window.addEventListener("offline", () => {
				vm.online = false;
			});

			vm.handleResize();
			window.addEventListener("resize", vm.handleResize);
		},
		getHardCodedSports() {
			let hardCodedSports = this.env.dropMenu.hardCodedSports;
			return hardCodedSports;
		},
		getThirdRowItems() {
			let thirdRowItems = this.env.dropMenu.thirdRowItems;

			return thirdRowItems;
		},
		handleResize() {
			const DESKTOP_WIDTH = 1023;
			this.$store.commit(
				"CHANGE_LAYOUT",
				window.innerWidth < DESKTOP_WIDTH ? "Mobile" : "Desktop"
			);
		},
		forcePlaceBet() {
			let vm = this;
			return new Promise((resolve, reject) => {
				vm.acceptOddChanges();
				vm.removeInvalidMatches();
				let now = new Date();
				if (
					vm.$store.getters.betSlip.find((bet) => {
						return bet.live;
					})
				) {
					if (
						now.getUTCHours() > 22 &&
						now.getUTCHours() < 5 &&
						vm.amount > 500000
					) {
						reject(
							"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT)
						);
						return vm.$notifications.add({
							message:
								"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT),
							title: "Bet limit warning",
							type: "warning",
							duration: 5000,
						});
					}
					if (
						now.getUTCHours() > 5 &&
						now.getUTCHours() < 22 &&
						vm.amount > 500000
					) {
						reject(
							"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT)
						);
						return vm.$notifications.add({
							message:
								"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT),
							title: "Bet limit warning",
							type: "warning",
							duration: 5000,
						});
					}
				}

				// Check whether the user is authenticated
				if (!JSON.parse(window.localStorage.getItem("authenticated"))) {
					vm.$notifications.add({
						message: "Please login to place a bet",
						title: "Authentication required",
						type: "warning",
						duration: 3000,
					});
					vm.$router.push("/login?next=" + vm.$route.fullPath);
					reject("Not authenticated");
					return;
				}

				// Check whether amount > 50
				if (vm.amount < 1) {
					vm.$notifications.add({
						message:
							"Minimum bet amount is " +
							vm.$options.filters.currency(MINIMUM_SPORTSBOOK_BET_AMOUNT),
						title: "Bet limit warning",
						type: "warning",
						duration: 3000,
					});
					reject(
						"Minimum bet amount is " +
							vm.$options.filters.currency(MINIMUM_SPORTSBOOK_BET_AMOUNT)
					);
					return;
				}

				// Get balances before placing the bet
				const wallet_balance_before = vm.$store.getters.user.balance;
				const wallet_bonus_before = vm.$store.getters.user.bonus;

				// Map betslip to endpoint requirements
				let betslip = vm.$store.getters.betSlip.map((bet) => {
					return {
						sub_type_id: bet.type,
						bet_pick: bet.odd.odd_key,
						odd_value: bet.odd.odd_value,
						outcome_id: bet.odd.outcome_id,
						sport_id: bet.odd.sport_id,
						special_bet_value: bet.odd.special_bet_value
							? bet.odd.special_bet_value
							: "",
						parent_match_id: bet.odd.parent_match_id,
						bet_type: bet.live ? 8 : 7,
					};
				});

				let oddValues = vm.$store.getters.betSlip.map((bet) => {
					return Number(bet.odd.odd_value);
				});

				let totalOdds = oddValues.reduce((a, b) => a * b, 1);

				// Build payload
				let payload = {
					profile_id: window.localStorage.getItem("user")
						? JSON.parse(window.localStorage.getItem("user")).id
						: "",
					stake: vm.amount.toString(),
					total_odd: totalOdds.toString(),
					src: "MOBILE_WEB",
					betslip: betslip,
					token: window.localStorage.getItem("token")
						? JSON.parse(window.localStorage.getItem("token"))
						: "",
					user_agent: localStorage.user_agent ? localStorage.user_agent : null,
					affiliate: localStorage.affiliate ? localStorage.affiliate : null,
				};

				if (vm.$cookie.get("btag")) {
					payload.affiliate_id = 19;
					payload.affiliate_tag = vm.$cookie.get("btag");
				}
				let liveMatches =
					vm.$store.getters.betSlip.findIndex((b) => b.live) > -1;

				const url = `${BASE_V2_URL}bet`;
				// Server request
				let delay = 0;
				setTimeout(() => {
					vm.$axios
						.post(url, payload)
						.then((response) => {
							vm.$store.commit("clearBetslip");
							vm.$notifications.add({
								message: response.data.message,
								title: "Bet placement successful",
								type: "success",
								duration: 5000,
							});
							resolve(true);
						})
						.catch((error) => {
							if (error.response) {
								if (error.response.status == 401) {
									window.localStorage.setItem("authenticated", false);
									window.localStorage.removeItem("user");
									window.localStorage.removeItem("token");

									vm.$notifications.add({
										message: "Your session has expired. Please login again",
										title: "Session expired",
										type: "error",
										duration: 5000,
									});
									vm.$router.replace("/login?next=" + vm.$route.fullPath);
									return;
								} else {
									vm.$notifications.add({
										message: error.response.data.message,
										title: "Bet placement error",
										type: "error",
										duration: 5000,
									});
								}
							} else {
							}
							reject(error);
						});
				}, delay);
			});
		},
		removeInvalidMatches() {
			this.$store.commit("removeInvalidMatches");
		},
		acceptOddChanges() {
			this.$store.getters.betSlip.map((bet) => {
				return (bet.changed = false);
			});
		},
		toBetslip() {
			this.$router.push({ path: "/betslip", query: this.$route.query });
		},
		showIncomeAccess() {
			this.show_income_access = true;
		},
		async loadSportsList() {
			let vm = this;

			const NAV_ALL_SPORTS_KEY = vm.env.dropMenu.navKeys.allSports
				.replace("{country}", vm.env.countryCode.toLowerCase())
				.replace("{version}", vm.env.dropMenu.navKeys.currentVersion.toLowerCase());

			// Get hard coded menu items
			let hardCodedSports = vm.getHardCodedSports();
			let hardCodedThirdRowItems = vm.getThirdRowItems();
			let validCount = 0;

			vm.$store.dispatch("getSports").then((sports) => {
				const hasSportsChanged = function (x, y) {
					return !_.isEqual(x, y);
				};

				// Get sports list stored in local storage
				let localStorageSports = localStorage.getItem(NAV_ALL_SPORTS_KEY)
					? localStorage.getItem(NAV_ALL_SPORTS_KEY)
					: "";

				if (hasSportsChanged(localStorageSports, JSON.stringify(sports))) {
					// Set main sports, favorite sports and other sports

					// Sport names of sports that will be initialized in mainSports
					let fixedPosSports = vm.env.dropMenu.fixedPosSports;
					// let fixedPosSports = ["soccer"];

					// MAIN SPORTS
					let mainSports = [];
					if (vm.$store.getters["navigation/mainSports"].length > 0) {
						// mainSports has already been initialized
						// Check if sports item exists in recently fetched sports otherwise set visible to false
						mainSports = vm.$store.getters["navigation/mainSports"];
						mainSports.forEach((sport) => {
							sport.timestamp = Date.now();
							if (sport.hard_coded == false) {
								const exists =
									typeof sports.find(
										(sprt) => sprt.sport_id === sport.sport_id
									) === "object";
								sport.visible = exists;
							} else {
								const sportInHardCoded = _.union(
									hardCodedSports,
									hardCodedThirdRowItems
								).find((sprt) => sprt.sport_id === sport.sport_id);

								if (sportInHardCoded) {
									let expiryValid = vm.isExpiryValid(sportInHardCoded);

									if (expiryValid) {
										if (
											(sport.new_badge == false &&
												sportInHardCoded.new_badge == true) ||
											(sport.new_badge == true &&
												sportInHardCoded.new_badge == true &&
												sport.expiry != sportInHardCoded.expiry)
										) {
											// New badge has been changed to visible or expiry date has changed and is valid
											// Update notification dot to be visible
											vm.$store.dispatch(
												"navigation/updateNotificationDotVisited",
												false
											);
											vm.$store.dispatch(
												"navigation/updateNotificationDotVisible",
												true
											);

											sport.new_badge = sportInHardCoded.new_badge;

											validCount += 1;
										}
									} else {
										// Hide new badge
										sport.new_badge = false;
									}
									sport.expiry = sportInHardCoded.expiry;
								}
							}
						});

						// Get hardcoded sports currently not in otherSports/mainSports
						let diffWithMainSports = _.differenceBy(
							vm.getHardCodedSports(),
							this.$store.getters["navigation/mainSports"],
							"sport_id"
						);
						let diffWithOtherSports = _.differenceBy(
							diffWithMainSports,
							this.$store.getters["navigation/otherSports"],
							"sport_id"
						);
						let diffWithThirdRow = _.differenceBy(
							diffWithOtherSports,
							this.$store.getters["navigation/thirdRow"],
							"sport_id"
						);

						// Add sports currently not in otherSports/mainSports/thirdRow to mainSports
						mainSports.push(...diffWithThirdRow);

						// Remove hard coded items from mainSports that are no longer in hardCoded Sports /thirdRow
						_.remove(mainSports, (sport) => {
							if (sport.hard_coded == true) {
								return (
									_.find(
										_.union(vm.getHardCodedSports(), vm.getThirdRowItems()),
										(hardCodedSport) => {
											return hardCodedSport.sport_id === sport.sport_id;
										}
									) == undefined
								);
							}
						});
					} else {
						// Initialize mainSports with hardCodedSports and fixedPosSports items
						if (localStorage.getItem(NAV_ALL_SPORTS_KEY) == null) {
							// mainSports will be initialized only during initial load. Will skip this if the user has removed all main sports items via drag and drop
							mainSports = sports.filter((sport) => {
								const sportName = vm.formatSportName(sport.sport_name);
								return fixedPosSports.includes(sportName);
							});

							// Add visible property
							mainSports = mainSports.map((sport) => {
								// Sets visibility true/false if the sport exists in the recently fetched sports list
								const exists =
									typeof mainSports.find(
										(sprt) => sprt.sport_id === sport.sport_id
									) === "object";
								return {
									timestamp: Date.now(),
									hard_coded: false,
									mobile_only: false,
									sport_id: sport.sport_id,
									sport_name: sport.sport_name,
									categories: sport.categories,
									top_leagues: sport.top_leagues,
									__proto__: sport.__proto__,
									new_badge: false,
									expiry: null,
									visible: exists,
									route: "sport",
									params: {
										sportName: vm.$options.filters.seoText(sport.sport_name),
									},
									query_params: null,
									image: null,
									label: sport.sport_name,
								};
							});
							// mainSports.push(...hardCodedSports);
							mainSports = this.arrayInsertAt(hardCodedSports, 0, mainSports);
						}
					}

					// commit mainSports to vuex storage
					vm.$store.commit("navigation/setMainSports", mainSports);

					// OTHER SPORTS
					let otherSports = [];
					if (vm.$store.getters["navigation/otherSports"].length > 0) {
						// otherSports has already been initialized
						// Check if sports item exists otherwise set visible to false
						otherSports = vm.$store.getters["navigation/otherSports"];
						otherSports.forEach((sport) => {
							sport.timestamp = Date.now();
							if (sport.hard_coded == false) {
								const exists =
									typeof sports.find(
										(sprt) => sprt.sport_id === sport.sport_id
									) === "object";
								sport.visible = exists;
							} else {
								const sportInHardCoded = _.union(
									hardCodedSports,
									hardCodedThirdRowItems
								).find((sprt) => sprt.sport_id === sport.sport_id);

								if (sportInHardCoded) {
									let expiryValid = vm.isExpiryValid(sportInHardCoded);

									if (expiryValid) {
										if (
											(sport.new_badge == false &&
												sportInHardCoded.new_badge == true) ||
											(sport.new_badge == true &&
												sportInHardCoded.new_badge == true &&
												sport.expiry != sportInHardCoded.expiry)
										) {
											// New badge has been changed to visible or expiry date has changed and is valid
											// Update notification dot to be visible
											vm.$store.dispatch(
												"navigation/updateNotificationDotVisited",
												false
											);
											vm.$store.dispatch(
												"navigation/updateNotificationDotVisible",
												true
											);

											sport.new_badge = sportInHardCoded.new_badge;

											validCount += 1;
										}
									} else {
										// Hide new badge
										sport.new_badge = false;
									}
									sport.expiry = sportInHardCoded.expiry;
								}
							}
						});

						// Get sports currently not in otherSports/mainSports/thirdRow
						let diffWithMainSports = _.differenceBy(
							sports,
							this.$store.getters["navigation/mainSports"],
							"sport_id"
						);
						let diffWithOtherSports = _.differenceBy(
							diffWithMainSports,
							this.$store.getters["navigation/otherSports"],
							"sport_id"
						);
						let diffWithThirdRow = _.differenceBy(
							diffWithOtherSports,
							this.$store.getters["navigation/thirdRow"],
							"sport_id"
						);
						// Add visible property to true as they are recently fetched
						diffWithThirdRow = diffWithThirdRow.map((sport) => {
							return {
								timestamp: Date.now(),
								hard_coded: false,
								mobile_only: false,
								sport_id: sport.sport_id,
								sport_name: sport.sport_name,
								categories: sport.categories,
								top_leagues: sport.top_leagues,
								__proto__: sport.__proto__,
								new_badge: false,
								expiry: null,
								visible: true,
								route: "sport",
								params: {
									sportName: vm.$options.filters.seoText(sport.sport_name),
								},
								query_params: null,
								image: null,
								label: sport.sport_name,
							};
						});
						// Add sports currently not in otherSports/mainSports to otherSports
						otherSports.push(...diffWithThirdRow);

						// Remove hard coded items from otherSports that are no longer in hardCoded Sports
						_.remove(otherSports, (sport) => {
							if (sport.hard_coded == true) {
								return (
									_.find(
										_.union(vm.getHardCodedSports(), vm.getThirdRowItems()),
										(hardCodedSport) => {
											return hardCodedSport.sport_id === sport.sport_id;
										}
									) == undefined
								);
							}
						});
					} else {
						// Initialize otherSports with items not in fixedPosSports
						if (localStorage.getItem(NAV_ALL_SPORTS_KEY) == null) {
							// otherSports will be initialized only during initial load. Will skip this if the user has removed all other sports items via drag and drop
							otherSports = sports.filter((sport) => {
								const sportName = vm.formatSportName(sport.sport_name);
								return !fixedPosSports.includes(sportName);
							});

							// Add visible property
							otherSports = otherSports.map((sport) => {
								// Sets visibility true/false if the sport exists in the recently fetched sports list
								const exists =
									_.findIndex(sports, (sprt) => {
										return sprt.sport_id === sport.sport_id;
									}) != -1;
								return {
									timestamp: Date.now(),
									hard_coded: false,
									mobile_only: false,
									sport_id: sport.sport_id,
									sport_name: sport.sport_name,
									categories: sport.categories,
									top_leagues: sport.top_leagues,
									__proto__: sport.__proto__,
									new_badge: false,
									expiry: null,
									visible: exists,
									route: "sport",
									params: {
										sportName: vm.$options.filters.seoText(sport.sport_name),
									},
									query_params: null,
									image: null,
									label: sport.sport_name,
								};
							});
						}
					}

					// commit otherSports to vuex storage
					vm.$store.commit("navigation/setOtherSports", otherSports);

					// THIRD ROW ITEMS
					let thirdRow = [];
					if (vm.$store.getters["navigation/thirdRow"].length > 0) {
						// thirdRow has already been initialized
						// Check if sports item exists otherwise set visible to false
						thirdRow = vm.$store.getters["navigation/thirdRow"];
						thirdRow.forEach((sport) => {
							sport.timestamp = Date.now();
							if (sport.hard_coded == false) {
								const exists =
									typeof sports.find(
										(sprt) => sprt.sport_id === sport.sport_id
									) === "object";
								sport.visible = exists;
							} else {
								const sportInHardCoded = _.union(
									hardCodedSports,
									hardCodedThirdRowItems
								).find((sprt) => sprt.sport_id === sport.sport_id);

								if (sportInHardCoded) {
									let expiryValid = vm.isExpiryValid(sportInHardCoded);

									if (expiryValid) {
										if (
											(sport.new_badge == false &&
												sportInHardCoded.new_badge == true) ||
											(sport.new_badge == true &&
												sportInHardCoded.new_badge == true &&
												sport.expiry != sportInHardCoded.expiry)
										) {
											// New badge has been changed to visible or expiry date has changed and is valid
											// Update notification dot to be visible
											vm.$store.dispatch(
												"navigation/updateNotificationDotVisited",
												false
											);
											vm.$store.dispatch(
												"navigation/updateNotificationDotVisible",
												true
											);

											sport.new_badge = sportInHardCoded.new_badge;

											validCount += 1;
										}
									} else {
										// Hide new badge
										sport.new_badge = false;
									}
									sport.expiry = sportInHardCoded.expiry;
								}
							}
						});

						// Get sports currently not in otherSports/mainSports
						let diffWithMainSports = _.differenceBy(
							vm.getThirdRowItems(),
							this.$store.getters["navigation/mainSports"],
							"sport_id"
						);
						let diffWithOtherSports = _.differenceBy(
							diffWithMainSports,
							this.$store.getters["navigation/otherSports"],
							"sport_id"
						);
						let diffWithThirdRow = _.differenceBy(
							diffWithOtherSports,
							this.$store.getters["navigation/thirdRow"],
							"sport_id"
						);

						// Add sports currently not in otherSports/mainSports/thirdRow to thirdRow
						thirdRow.push(...diffWithThirdRow);

						// Remove hard coded items from thirdRow that are no longer in hardCoded Sports / thirdRow
						_.remove(thirdRow, (sport) => {
							if (sport.hard_coded == true) {
								return (
									_.find(
										_.union(vm.getHardCodedSports(), vm.getThirdRowItems()),
										(hardCodedSport) => {
											return hardCodedSport.sport_id === sport.sport_id;
										}
									) == undefined
								);
							}
						});
					} else {
						// Initialize otherSports with items not in fixedPosSports
						if (localStorage.getItem(NAV_ALL_SPORTS_KEY) == null) {
							// otherSports will be initialized only during initial load. Will skip this if the user has removed all other sports items via drag and drop
							thirdRow = hardCodedThirdRowItems;
						}
					}

					// commit otherSports to vuex storage
					vm.$store.commit("navigation/setThirdRow", thirdRow);

					// Set sports in vuex storage and update local storage
					vm.$store.commit("SET_SPORTS", sports);
					localStorage.setItem(NAV_ALL_SPORTS_KEY, JSON.stringify(sports));

					// Place mainSports and otherSports arrays to unionSports array for the scrollable top menu
					const unionSports = _.union(
						vm.$store.getters["navigation/mainSports"],
						vm.$store.getters["navigation/otherSports"],
						vm.$store.getters["navigation/thirdRow"]
					);

					if (validCount == 0) {
						// sets to false if there are no "new banners" that have not expired
						vm.$store.dispatch(
							"navigation/updateNotificationDotVisible",
							false
						);
					}
					vm.$store.commit("navigation/setUnionSports", unionSports);
				} else {
					// Set sports in vuex storage without updating local storage - used as failsafe to display sports in desktop mode
					vm.$store.commit("SET_SPORTS", sports);
				}
			});
		},
		isExpiryValid(sportInHardCoded) {
			const dateRegex = "^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$";
			const dateTimeRegex =
				"^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])\\s(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$";
			let isExpiryValid = false;
			let expiry = sportInHardCoded.expiry;
			if (expiry != null) {
				if (expiry.isMatch(dateRegex)) {
					isExpiryValid = !isPast(
						parse(sportInHardCoded.expiry, "yyyy-MM-dd", new Date())
					); // isPast returns true if date is in the past hence not a valid expiry date
				} else if (expiry.isMatch(dateTimeRegex)) {
					isExpiryValid = !isPast(
						parse(sportInHardCoded.expiry, "yyyy-MM-dd HH:mm", new Date())
					);
				}
			}
			return isExpiryValid;
		},
		handleDeeplink() {
			let vm = this;
			let is_deeplink = utils.getParameterByName("action") == "instantbet";
			if (is_deeplink) {
				// Get params
				let params = {
					parent_match_id: utils.getParameterByName("parent_match_id"),
					sub_type_id: utils.getParameterByName("sub_type_id"),
					odd_key: utils.getParameterByName("odd_key"),
					odd_value: utils.getParameterByName("odd_value"),
					special_bet_value: utils.getParameterByName("special_bet_value"),
					stake: utils.getParameterByName("stake"),
				};
				vm.affiliateData = params;
				this.getAffiliateMatchDetails();
			}

			let is_deeplink_live =
				utils.getParameterByName("action") == "instantbetlive";
			if (is_deeplink_live) {
				// Get params
				let params = {
					parent_match_id: utils.getParameterByName("parent_match_id"),
					sub_type_id: utils.getParameterByName("sub_type_id"),
					odd_key: utils.getParameterByName("odd_key"),
					odd_value: utils.getParameterByName("odd_value"),
					special_bet_value: utils.getParameterByName("special_bet_value"),
					stake: utils.getParameterByName("stake"),
				};
				vm.affiliateData = params;
				this.getAffiliateLiveMatchDetails();
			}

			if (this.$route.query.action === "instantbet") {
				vm.affiliateData = this.$route.query;
				this.getAffiliateMatchDetails();
			}

			if (this.$route.query.action === "instantbetlive") {
				vm.affiliateData = this.$route.query;
				this.getAffiliateMatchDetails();
			}

			if (this.$route.query.btag) {
				this.btag = this.$route.query.btag || null;
				this.$cookie.set("btag", this.btag, 365);
			}
			if (utils.getParameterByName("btag")) {
				this.btag = utils.getParameterByName("btag") || null;
				this.$cookie.set("btag", this.btag, 365);
			}
		},
		getAffiliateMatchDetails() {
			let vm = this;
			vm.$axios
				.get(
					`${BASE_URL}/match?parent_match_id=${vm.affiliateData.parent_match_id}`
				)
				.then((response) => {
					vm.affiliateMatchData = response.data.data;
					vm.affiliateMatchMeta = response.data.meta;
					if (vm.affiliateMatchMeta == null) {
						vm.$notifications.add({
							message: "Match add unsuccessful, expired match",
							title: "Deeplink error",
							type: "error",
							duration: 5000,
						});

						return;
					}
					vm.addToBetslip();
				})
				.catch((error) => {
					console.error(error);
				});
		},

		getAffiliateLiveMatchDetails() {
			this.$axios
				.get(
					`${LIVE_URL}/match?parent_match_id=${this.affiliateData.parent_match_id}`
				)
				.then((response) => {
					this.affiliateMatchData = response.data.data;
					this.affiliateMatchMeta = response.data.meta;
					if (this.affiliateMatchMeta == null) {
						vm.$notifications.add({
							message: "Match add unsuccessful, expired match",
							title: "Deeplink error",
							type: "error",
							duration: 5000,
						});
						return;
					}
					this.addToBetslip();
				})
				.catch((error) => {
					console.error(error);
				});
		},

		addToBetslip() {
			var vm = this;
			let subTypeIdFilter = vm.affiliateMatchData.filter(
				(x) => x.sub_type_id == vm.affiliateData.sub_type_id
			);
			if (subTypeIdFilter.length == 0) {
				vm.$notifications.add({
					message: "Match add unsuccessful, check the parameters",
					title: "Deeplink error",
					type: "error",
					duration: 5000,
				});
				return;
			}
			subTypeIdFilter = subTypeIdFilter[0];
			let oddsFilter = subTypeIdFilter.odds.filter(
				(x) =>
					x.odd_key == vm.affiliateData.odd_key &&
					(vm.affiliateData.special_bet_value == ""
						? x.special_bet_value == "" || x.special_bet_value == null
						: vm.affiliateData.special_bet_value == x.special_bet_value)
			);
			if (oddsFilter.length == 0) {
				vm.$notifications.add({
					message: "Match add unsuccessful, check the parameters",
					title: "Deeplink error",
					type: "error",
					duration: 5000,
				});
				return;
			}
			oddsFilter = oddsFilter[0];
			let odd = {
				display: oddsFilter.display,
				odd_key: oddsFilter.odd_key,
				odd_value: oddsFilter.odd_value,
				outcome_id: oddsFilter.outcome_id,
				special_bet_value: oddsFilter.special_bet_value || "",
				parent_match_id: vm.affiliateData.parent_match_id,
			};
			vm.odd = odd;
			let bet = {
				matchId: vm.affiliateMatchMeta.match_id,
				odd,
				type: vm.affiliateData.sub_type_id,
				market: subTypeIdFilter.name,
				display: `${vm.affiliateMatchMeta.home_team} vs ${vm.affiliateMatchMeta.away_team}`,
				startTime: vm.affiliateMatchMeta.start_time,
				live: false,
				active: true,

				// Coola payload
				parent_match_id: odd.parent_match_id,
				game_description: `${vm.affiliateMatchMeta.home_team} vs. ${vm.affiliateMatchMeta.away_team}`,
				bet_pick: odd.odd_key,
				sub_type_id: vm.affiliateData.sub_type_id,
				market_name: subTypeIdFilter.name,
				odd_key: odd.odd_key,
				odd_value: odd.odd_value,
				outcome_id: odd.outcome_id,
				special_bet_value: odd.specialBetValue || "",
				bet_type: "prebet",
				home_team: vm.affiliateMatchMeta.home_team,
				away_team: vm.affiliateMatchMeta.away_team,
				start_time: vm.affiliateMatchMeta.start_time,
				sport_id: vm.affiliateMatchMeta.sport_id,
			};
			if (
				this.$store.state.betSlip.find(function (bet) {
					return (
						bet.matchId == vm.affiliateMatchMeta.match_id && bet.odd == odd
					);
				})
			) {
				this.removeFromBetslip(bet);
				return;
			}

			// if my match has a selected odd, remove it
			if (
				this.$store.state.betSlip.find(function (bet) {
					return bet.matchId == vm.affiliateMatchMeta.match_id;
				})
			)
				this.removeFromBetslip(bet);

			/*
                      add me to betslip after confirming that i'm not already there
                      and removing my match if it already exists
                  */
			this.$store.commit("updateStake", parseFloat(vm.affiliateData.stake));
			this.$store.commit("addToBetslip", bet);

			this.$notifications.add({
				message: "Bet successfully added to betslip",
				title: "Deeplink success",
				type: "success",
				duration: 5000,
			});
			this.toBetslip();
		},
		removeFromBetslip(bet) {
			this.selected = "";
			var vm = this;
			this.$store.commit("removeFromBetslip", {
				matchId: bet.matchId,
				odd: bet.odd,
				type: bet.type,
				market: bet.market,
				display: bet.display,
				startTime: bet.startTime,
				live: bet.live,
				active: bet.active,
			});
		},

		getParameterByName(name, url) {
			url = window.location.href;
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return "";
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		},
		async resetSportsList() {
			let vm = this;

			await vm.$store.dispatch('navigation/clearMainSports');
			await vm.$store.dispatch('navigation/clearOtherSports');
			await vm.$store.dispatch('navigation/clearFavoriteSports');
			await vm.$store.dispatch('navigation/clearThirdRow');
			await vm.$store.dispatch('navigation/clearAllSports');

			// // Clear nav items in local storage
			// localStorage.removeItem(NAV_MAIN_SPORTS_KEY);
			// localStorage.removeItem(NAV_OTHER_SPORTS_KEY);
			// localStorage.removeItem(NAV_FAVORITE_SPORTS_KEY);
			// localStorage.removeItem(NAV_THIRD_ROW_KEY);
			// localStorage.removeItem(NAV_ALL_SPORTS_KEY);
			//
			// // Clear vue store nav items
			// vm.$store.commit("navigation/setMainSports", []);
			// vm.$store.commit("navigation/setOtherSports", []);
			// vm.$store.commit("navigation/setThirdRow", []);
			// vm.$store.commit("navigation/setFavoriteSports", []);
			await this.loadSportsList();
		},
		async refreshSportsList() {
			await this.loadSportsList();
		},
	},
};
</script>

<style lang="scss">
@import "../assets/styles/_globals.scss";
@import "../assets/styles/_utils.scss";
@import "../assets/styles/_components.scss";
@import "../assets/styles/notifications.scss";

.online {
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 99999;
	position: fixed;
	top: 0;
	width: 100%;
	font-size: var(--font-small);
	color: var(--white);
	.icon {
		fill: red;
	}
	p {
		padding: 10px;
	}
}

@keyframes bounce {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-5px);
	}
}
.banner {
	position: fixed;
	z-index: 2147483647;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	transition: opacity 0.3s ease;
	cursor: pointer;
	&__container {
		position: relative;
		width: 90vw;
		max-width: 768px;
		margin: 0 auto;
		top: 30%;
		cursor: default;
	}
	&__content {
		background-color: #fcd200;
		color: #2a3482;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		&__action {
			padding: 8px 30px;
			background-color: #2a3482;
			color: var(--white);
			text-decoration: underline;
			font-size: var(--font-large);
			font-style: italic;
			font-weight: var(--font-weight-normal);
			outline: none;
			border: none;
		}
		&__info {
			margin: 14px 0;
			font-size: var(--font-large);
			font-weight: var(--font-weight-normal);
		}
		&__title {
			font-size: var(--font-large);
			font-style: italic;
			font-weight: var(--font-weight-bold);
			margin: 12px 0;
		}
		&__wrapper {
			display: flex;
			flex-direction: column;
			padding: 40px 0;
			justify-content: center;
			align-items: center;
		}
	}
	&__close {
		position: absolute;
		height: 25px;
		width: 25px;
		border-radius: 50%;
		background: var(--white);
		color: #454545;
		font-size: 1rem;
		right: -12.5px;
		top: -12.5px;
		text-align: center;
		line-height: 25px;
		box-shadow: var(--shadow);
		cursor: pointer;
	}
	&__image {
		width: 100%;
	}

	&__message__container {
		position: absolute;
		top: 20px;
		left: 5%;
		width: 60%;
		display: flex;
		flex-direction: column;
	}
	&__message_title {
		color: #fef341;
		font-size: 1.4rem;
		font-weight: var(--font-weight-medium);
	}
	&__message_content {
		color: var(--white);
		font-size: 1.2rem;
		font-weight: var(--font-weight-medium);
		line-height: 1.4rem;
	}

	/* add some base styles for the portal containers */
	#bottom-sheet,
	#bottom-sheet-stack {
		position: relative;
		z-index: 0;
	}
}
</style>
